
import ScanImg from '@/assets/scan.png'
import CHeader from '@/components/Header'
import CPosition from '@/components/Position'
import {
formatDate
} from '@utils'
import {
scanQRCode
} from '@utils/wechat'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'Order',
components: {
Group,
Cell,
XInput,
XButton,
CHeader,
CPosition
},

data() {
return {
CAR_NO:'',
USERNAME:'',
PHONE:'',
scan_type:1,
ScanImg: ScanImg,
}
},
computed: {
position() {
return this.$store.getters.getPosition
},
},
created() {
this.TYPE = this.$route.query.TYPE || 0
this.$store.dispatch('baiduPosition')
},
mounted(){
this.loadData();
},
methods: {
openScan() {
let _this = this;
scanQRCode(_this.scan_type).then(res => {
console.log('scan result', res)
_this.CAR_NO=res;
_this.saveData()
})
},
saveData() {
let _this = this

if(_this.USERNAME==''||_this.PHONE==''){


return;
}




if(_this.CAR_NO==''){
return;
}
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Update_Car_Driver'
return this.$post(url, {
CAR_NO: _this.CAR_NO,
USERNAME:_this.USERNAME,
PHONE:_this.PHONE,
}).then(
response => {
this.$toast.success('配车成功')
}
).catch(
response => {
this.$toast.warn(response.Msg)
}
)
},
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Get_Car_By_Driver'
return this.$post(url, {}).then(
response => {
let res = JSON.parse(response)
_this.CAR_NO = res[0].CAR_NO;
_this.USERNAME = res[0].DRIVER;
_this.PHONE = res[0].DRIVER_TEL;
if(_this.CAR_NO&&_this.USERNAME&& _this.PHONE){
_this.saveData()
}
}
).catch(
response => {
_this.$toast.warn(response.Msg)
}
)
},
}
}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/Pc.vue